import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import PlanDetail from '../plans/PlanDetail'
import { CardArrowSvg } from 'src/assets/index'
const PATH: any = []
const BankDetailsRender = ({ myBanks }: any) => {
  // console.log(myBanks)

  useEffect(() => {
    getAllPaths()
  }, [])
  let location = useLocation()

  const getAllPaths = () => {
    myBanks?.map((item: any) => {
      return PATH.push({ id: item?.id, title: `${(<PlanDetail />)}` })
    })
  }
  return (
    <div>
      {myBanks
        ? myBanks?.map((item: any) => {
            return (
              <Link
                to={`/Bank/${item?.id}`}
                state={{ backgroundLocation: location }}
                className="bank_delete_link"
                key={item.id}
              >
                <div className="bank_account_details" key={item.id}>
                  <div className="bank_logo">
                    <img src={item.bank_logo} alt="" />
                  </div>

                  <div className="bank_name_account">
                    <p className="account_num">{item.account_number}</p>
                    <p className="account_name">
                      {item.account_name.toLowerCase()}
                    </p>
                  </div>

                  <div className="card_arrow">
                    <img src={CardArrowSvg} alt="" className="" />
                  </div>
                </div>
              </Link>
            )
          })
        : null}
    </div>
  )
}
function getCustomModalsBankPathId(id: any) {
  return PATH.find((image: any) => image.id === id)
}
export { BankDetailsRender, getCustomModalsBankPathId }
